/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
==========================================================================================*/


const getters = {

  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  cognitoUser: (state) => {
    return state.cognitoUser;
  },
  isSignedIn: (state) => {
    return state.isSignedIn;
  },
  rememberMe: (state) => {
    return state.rememberMe;
  },
  isSingleSignedIn: (state) => {
    return state.isSingleSignedIn;
  },
  inviteId: (state) => {
    return state.inviteId;
  },
  smsCodeVal: (state) => {
    return state.smsCodeVal;
  },
  hasConjoint: (state) => {
    return state.hasConjoint;
  }
};

export default getters;